import { useApi } from 'services';

export const useGetContactById = (idPerson, idContact) => useApi(
    `/v2/person/${idPerson}/contact/${idContact}`,
    'GET',
    {},
    {},
    true
);

export const useGetContactsByIdPerson = (idPerson) => useApi(
    `/v2/person/${idPerson}/contact`,
    'GET',
    {},
    {},
    true
);

export const useCreateContact = (idPerson) => useApi(
    `/v2/person/${idPerson}/contact`,
    'POST',
    {},
    {},
    true
);

export const useUpdateContact = (idPerson, idContact) => useApi(
    `/v2/person/${idPerson}/contact/${idContact}`,
    'PUT',
    {},
    {},
    true
);

export const useExpireContact = (idPerson, idContact) => useApi(
    `/v2/person/${idPerson}/contact/${idContact}`,
    'DELETE',
    {},
    {},
    true
);
